import NavigationFooter from './NavigationFooter';

export default NavigationFooter;
